export default __webpack_public_path__ + "static/media/icon_other_OptionalEngagement.feedfe2a.png";